import { DynamicStandaloneSliderSwiper } from '@/components/Slider/Swiper';
import { DynamicStandaloneComponents } from '@/components/standalone';
import { LabradorComponent } from '@/types/component';
import { pathToComponent } from '@/utils/index';
import withDebugMetadata from '@/utils/withDebugMetadata';

const LabradorSlider: LabradorComponent = ({ type, data, meta }) => {
  const name = ('Slider' + (pathToComponent(meta.path) || 'Swiper')) as keyof typeof DynamicStandaloneComponents;
  const SliderComponent = DynamicStandaloneComponents[name] as typeof DynamicStandaloneSliderSwiper;

  return <SliderComponent {...data} {...withDebugMetadata({ type, meta })} />;
};

export default LabradorSlider;
